import { createHotkeys } from '@app/core/hotkeys/create-hotkeys';
import { defineMessage } from 'react-intl';

/** Stream hotkeys config. Use .get(category, id) for the key string (e.g. tooltips). */
export const streamHotkeys = createHotkeys({
  playback: {
    label: defineMessage({
      id: 'logger.streamScreen.hotkeys.category.playback',
      defaultMessage: 'Reproducción',
    }),
    hotkeys: {
      PLAY_PAUSE: {
        key: 'k,space',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.PLAY_PAUSE.label',
          defaultMessage: 'Reproducir / pausar',
        }),
      },
    },
  },
  focus: {
    label: defineMessage({
      id: 'logger.streamScreen.hotkeys.category.focus',
      defaultMessage: 'Foco',
    }),
    hotkeys: {
      FOCUS_BACK_5M: {
        key: 'j',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.FOCUS_BACK_5M.label',
          defaultMessage: 'Mover foco 5 minutos atrás',
        }),
      },
      STREAM_BACK_1H: {
        key: 'shift+j',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.STREAM_BACK_1H.label',
          defaultMessage: 'Mover foco 1 hora atrás',
        }),
      },
      FOCUS_FORWARD_5M: {
        key: 'l',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.FOCUS_FORWARD_5M.label',
          defaultMessage: 'Mover foco 5 minutos adelante',
        }),
      },
      STREAM_FORWARD_1H: {
        key: 'shift+l',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.STREAM_FORWARD_1H.label',
          defaultMessage: 'Mover foco 1 hora adelante',
        }),
      },
      FOCUS_FULL_IN: {
        key: 'ctrl+arrowup,command+arrowup',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.FOCUS_FULL_IN.label',
          defaultMessage: 'Zoom completo en cursor o selección',
        }),
      },
      FOCUS_FULL_OUT: {
        key: 'ctrl+arrowdown,command+arrowdown',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.FOCUS_FULL_OUT.label',
          defaultMessage: 'Zoom completo hacia afuera',
        }),
      },
      FOCUS_ZOOM_SELECTION_IN: {
        key: 'ctrl+i,command+i',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_IN.label',
          defaultMessage: 'Zoom al inicio de la selección',
        }),
      },
      FOCUS_ZOOM_SELECTION_OUT: {
        key: 'ctrl+o,command+o',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_OUT.label',
          defaultMessage: 'Zoom al final de la selección',
        }),
      },
      ZOOM_IN_FOCUS: {
        key: 'shift+arrowup',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.ZOOM_IN_FOCUS.label',
          defaultMessage: 'Zoom in en foco',
        }),
      },
      ZOOM_OUT_FOCUS: {
        key: 'shift+arrowdown',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.ZOOM_OUT_FOCUS.label',
          defaultMessage: 'Zoom out en foco',
        }),
      },
    },
  },
  cursor: {
    label: defineMessage({
      id: 'logger.streamScreen.hotkeys.category.cursor',
      defaultMessage: 'Cursor',
    }),
    hotkeys: {
      CURSOR_BACK_1S: {
        key: 'arrowleft',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.CURSOR_BACK_1S.label',
          defaultMessage: 'Mover cursor 1 segundo atrás',
        }),
      },
      CURSOR_BACK_5S: {
        key: 'shift+arrowleft',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.CURSOR_BACK_5S.label',
          defaultMessage: 'Mover cursor 5 segundos atrás',
        }),
      },
      CURSOR_FORWARD_1S: {
        key: 'arrowright',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.CURSOR_FORWARD_1S.label',
          defaultMessage: 'Mover cursor 1 segundo adelante',
        }),
      },
      CURSOR_FORWARD_5S: {
        key: 'shift+arrowright',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.CURSOR_FORWARD_5S.label',
          defaultMessage: 'Mover cursor 5 segundos adelante',
        }),
      },
    },
  },
  selection: {
    label: defineMessage({
      id: 'logger.streamScreen.hotkeys.category.selection',
      defaultMessage: 'Selección',
    }),
    hotkeys: {
      START_CURSOR_SELECTION: {
        key: 'shift+i',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.START_CURSOR_SELECTION.label',
          defaultMessage: 'Iniciar selección desde el cursor',
        }),
      },
      END_CURSOR_SELECTION: {
        key: 'shift+o',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.END_CURSOR_SELECTION.label',
          defaultMessage: 'Terminar selección desde el cursor',
        }),
      },
      INCREMENT_CURSOR_SELECTION: {
        key: 'ctrl+shift+arrowup,command+shift+arrowup',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.INCREMENT_CURSOR_SELECTION.label',
          defaultMessage: 'Aumentar rango de selección 5 segundos',
        }),
      },
      DECREMENT_CURSOR_SELECTION: {
        key: 'ctrl+shift+arrowdown,command+shift+arrowdown',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.DECREMENT_CURSOR_SELECTION.label',
          defaultMessage: 'Reducir rango de selección 5 segundos',
        }),
      },
      START_PLAY_TS_SELECTION: {
        key: 'i',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.START_PLAY_TS_SELECTION.label',
          defaultMessage: 'Iniciar selección desde el tiempo actual',
        }),
      },
      END_PLAY_TS_SELECTION: {
        key: 'o',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.END_PLAY_TS_SELECTION.label',
          defaultMessage: 'Terminar selección desde el tiempo actual',
        }),
      },
      ADD_CHUNK_FROM_FOCUS_SELECTION: {
        key: 'p',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.ADD_CHUNK_FROM_FOCUS_SELECTION.label',
          defaultMessage: 'Agregar selección al fragmento conjunto',
        }),
      },
      CREATE_FRAGMENT: {
        key: 'f',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.CREATE_FRAGMENT.label',
          defaultMessage: 'Crear fragmento desde la selección',
        }),
      },
      DOWNLOAD_SELECTION: {
        key: 'd',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.DOWNLOAD_SELECTION.label',
          defaultMessage: 'Descargar selección',
        }),
      },
      CLEAR_SELECTION: {
        key: 'esc',
        label: defineMessage({
          id: 'logger.streamScreen.hotkeys.CLEAR_SELECTION.label',
          defaultMessage: 'Limpiar selección',
        }),
      },
    },
  },
});
